const navigationKeys = new Set(['ArrowLeft', 'ArrowRight', 'Home', 'End'])

export default function tabs({ initialTab = '', serverDriven = false } = {}) {
  return {
    tab: initialTab,
    tabs: [],
    serverDriven,

    tabElements() {
      const tablist = this.$root.querySelector('[role="tablist"]')

      return Array.from(tablist?.querySelectorAll(':scope > [role="tab"][data-tab]') ?? [])
        .filter(element => !this.isTabInteractionBlocked(element))
    },

    isTabInteractionBlocked(element) {
      return element?.disabled === true || (
        element?.hasAttribute('aria-disabled') === true &&
        element.getAttribute('aria-disabled') !== 'false'
      )
    },

    tabKeys() {
      return this.tabElements()
        .map(element => element.dataset.tab)
        .filter(Boolean)
    },

    syncTabs() {
      const rendered = this.tabKeys()

      if (rendered.length === 0) {
        return
      }

      this.tabs = rendered

      if (!this.serverDriven && !this.tabs.includes(this.tab)) {
        this.tab = this.tabs[0]
      }
    },

    activeTab() {
      return this.serverDriven
        ? (this.$root.dataset.activeTab ?? '')
        : this.tab
    },

    isTabActive(tab) {
      return this.activeTab() === tab
    },

    tabIndex(tab) {
      return this.isTabActive(tab) ? 0 : -1
    },

    selectTab(tab) {
      this.syncTabs()

      if (this.serverDriven || !this.tabs.includes(tab)) {
        return
      }

      this.tab = tab
    },

    activateTab(event, tab) {
      if (this.isTabInteractionBlocked(event.currentTarget)) {
        event.preventDefault()
        event.stopImmediatePropagation()
        return
      }

      this.selectTab(tab)
    },

    navigateTabs(event) {
      if (!navigationKeys.has(event.key)) {
        return
      }

      if (this.isTabInteractionBlocked(event.currentTarget)) {
        event.preventDefault()
        return
      }

      const tabs = this.tabElements()
      const currentIndex = tabs.indexOf(event.currentTarget)

      if (currentIndex < 0 || tabs.length === 0) {
        return
      }

      event.preventDefault()

      let nextIndex

      if (event.key === 'Home') {
        nextIndex = 0
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1
      } else {
        const direction = event.key === 'ArrowRight' ? 1 : -1
        nextIndex = (currentIndex + direction + tabs.length) % tabs.length
      }

      const nextTab = tabs[nextIndex]

      nextTab.focus()
      nextTab.click()
    }
  }
}
